import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=674aa5f6&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=674aa5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674aa5f6",
  null
  
)

export default component.exports